import { render, staticRenderFns } from "./baidu-map.vue?vue&type=template&id=1bd13a9e"
import script from "./baidu-map.vue?vue&type=script&lang=js"
export * from "./baidu-map.vue?vue&type=script&lang=js"
import style0 from "./baidu-map.vue?vue&type=style&index=0&id=1bd13a9e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd13a9e')) {
      api.createRecord('1bd13a9e', component.options)
    } else {
      api.reload('1bd13a9e', component.options)
    }
    module.hot.accept("./baidu-map.vue?vue&type=template&id=1bd13a9e", function () {
      api.rerender('1bd13a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/map/baidu-map.vue"
export default component.exports